import { Button } from "@material-ui/core";
import React from "react";
import {
  Box,
  ButtonBase,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import { validatePincode } from "../../../Supporting files/HelpingFunction";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SlidingPanel from "react-sliding-side-panel";
interface Props {
  attrName: string;
  open_status: boolean;
  value_update: Function;
}

const InvestmentForm: React.FC<Props> = ({
  open_status,
  value_update,
  attrName,
}) => {
  const [wantToInvest, setWantToInvest] = React.useState("");
  const [payMode, setPayMode] = React.useState("");
  const [investage, setInvestAge] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [warnAge, setWarnAge] = React.useState(false);
  const [warnpayMode, setWarnPayMode] = React.useState(false);
  const [warnGender, setWarnGender] = React.useState(false);
  const [warnPincode, setWarnPincode] = React.useState(false);
  const [warnWantToInvest, setWarnWantToInvest] = React.useState(false);
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName == "payMode") {
      setPayMode(event.target.value as string);
      setWarnPayMode(event.target.value.toString().length == 0 ? true : false);
    } else if (attrName === "investAge") {
      setInvestAge(event.target.value as string);
      setWarnAge(event.target.value.toString().length == 0 ? true : false);
    } else if (attrName === "gender") {
      setGender(event.target.value as string);
      setWarnGender(event.target.value.toString().length == 0 ? true : false);
    }
  };

  const handleChangeTextField = (value: string, attrName: string) => {
    if (attrName == "wantToInvest") {
      setWantToInvest(value);
      if (parseInt(value) >= 500 && parseInt(value) <= 500000) {
        setWarnWantToInvest(false);
      } else {
        setWarnWantToInvest(true);
      }
    } else if (attrName == "pincode") {
      setPincode(value);
      setWarnPincode(!validatePincode(value));
    }
  };

  const validateInvestmentForm = () => {
    let warn_want_to_invest = false;
    if (parseInt(wantToInvest) > 500 && parseInt(wantToInvest) < 500000) {
      warn_want_to_invest = false;
    } else {
      warn_want_to_invest = true;
    }
    let warn_pay_mode = payMode.toString().length == 0 ? true : false;
    let warn_age = investage.toString().length == 0 ? true : false;
    let warn_gender = gender.toString().length == 0 ? true : false;
    let warn_pincode = pincode.toString().length == 0 ? true : false;

    setWarnWantToInvest(warn_want_to_invest);
    setWarnPayMode(warn_pay_mode);
    setWarnAge(warn_age);
    setWarnGender(warn_gender);
    setWarnPincode(warn_pincode);

    if (
      warn_want_to_invest === false &&
      warn_pay_mode === false &&
      warn_age === false &&
      warn_gender === false &&
      warn_pincode === false
    ) {
    }
  };
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  const InvestAge_data = [
    { key: "18 years", value: "18 years" },
    { key: "20 years", value: "20 years" },
    { key: "21 years", value: "21 years" },
    { key: "22 years", value: "22 years" },
    { key: "23 years", value: "23 years" },
    { key: "24 years", value: "24 years" },
  ];
  const gender_data = [
    { key: "male", value: "Male" },
    { key: "female", value: "Female" },
  ];
  const paymode_data = [
    { key: "Quaterly", value: "Quaterly" },
    { key: "Half yearly", value: "Half yearly" },
    { key: "Annually", value: "Annually" },
  ];
  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      backdropClicked={() => value_update(attrName, false)}>
      <div>
        {pageStatus == 2 ? null : (
          <Grid container spacing={3} alignItems="center">
            <Grid xs={6}>
              <h4 className="mb-0 mt-2">Investment Plan </h4>
            </Grid>
          </Grid>
        )}
        {pageStatus == 2 ? null : (
          <div className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={12} sx={{ padding: "0px" }}>
                <div>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    className="mb-4">
                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField rupeeIcon"
                        title="Want to Invest"
                        value={wantToInvest}
                        value_update={updateMasterState}
                        attrName={setWantToInvest}
                        warn_status={warnWantToInvest}
                      />
                    </Grid>
                    <Grid xs={6} className="inputField">
                      <SelectDropdown
                        class_name="inputField"
                        title="Pay Mode"
                        value={payMode}
                        attrName={setPayMode}
                        value_update={updateMasterState}
                        dropdown_data={paymode_data}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} className="mb-4 mt-2">
                    <Grid xs={4} className="inputField">
                      <SelectDropdown
                        class_name="inputField"
                        title="Age"
                        value={investage}
                        attrName={setInvestAge}
                        value_update={updateMasterState}
                        dropdown_data={InvestAge_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={4} className="inputField">
                      <SelectDropdown
                        class_name="inputField"
                        title="Gender"
                        value={gender}
                        attrName={setGender}
                        value_update={updateMasterState}
                        dropdown_data={gender_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={4}>
                      <RKTextField
                        class_name="inputField"
                        title="Pincode"
                        value={pincode}
                        value_update={updateMasterState}
                        attrName={setPincode}
                        warn_status={warnPincode}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>
        )}
        {pageStatus == 2 ? (
          <Grid container spacing={2}>
            <Grid xs={12} className="tick_animation">
              <svg
                className="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52">
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
              <p className="quote_success">
                New Investment Policy has been added successfully!
              </p>
            </Grid>
          </Grid>
        ) : null}
        <Grid container spacing={2}>
          {pageStatus == 2 ? null : (
            <Grid
              xs={12}
              style={{ textAlign: "center", position: "relative" }}
              className="ctaBtn">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  changePageStatus(true);
                }}>
                {pageStatus == 1 ? "Submit" : "Continue"}
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </SlidingPanel>
  );
};

export default InvestmentForm;
